<template>
<div id="fetching-content">

	<div class="align-c">
		<p>Fetching content...</p>
	</div>
			

</div>
</template>

<script>

export default {
	
	components: { 		
		
	},

	data(){ return {
			

	}},

	computed: {

		

	},

	methods: {

		

	},

}
</script>



// WEBPACK FOOTER //
// src/components/FetchingContent.vue